import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  Button,
  useDisclosure,
  Image,
  Text,
  Icon,
  Flex,
  Box,

  Textarea,
  Center,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  useToast,
} from "@chakra-ui/react";
import { RiFeedbackFill, RiImage2Line } from "@remixicon/react";
import { useCallback, useState } from "react";
import { Field, Form, Formik, FormikErrors } from "formik";
import { useDropzone } from "react-dropzone";
import { isPhone } from "@/utils/utils";
import { Feedback } from "@/types/user";
import { useUpdateFeedbackInfoMutation } from "@/services/api/endpoints/users";
import { ServerError } from "@/types/errors";

const FeedbackPopover = () => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const toast = useToast();
  const [files, setFiles] = useState<string[]>([]);
  
  const [updateFeedbackInfo] = useUpdateFeedbackInfoMutation();

  const form = {
    problem: "",
    img: "",
    phone: "",
  } as Feedback;

  const handleValidate = (values: Feedback) => {
    const errors: FormikErrors<{
      problem: string;
      img: string;
      phone: string;
    }> = {};
    if (!values.problem) {
      errors.problem = "问题和意见不能为空";
    }
    if (!files.length) {
      errors.img = "请上传图片";
    }
    if (!values.phone) {
      errors.phone = "手机号不能为空";
    }else if (!isPhone(values.phone)) {
      errors.phone = "无效的手机号";
    }
    return errors;
  };

  const handleSubmit = async (values: Feedback, {resetForm}:any) => {
    const subForm = {
      problem: values.problem,
      img: files[0],
      phone: values.phone
    }
    console.log(subForm);

    const result = await updateFeedbackInfo(subForm).unwrap().catch((e) => {
      toast({
        title: (e as ServerError).message,
        position: 'top',
        status: 'error',
        duration: 2000,
        isClosable: true,
      })
    })

    if(result){
      toast({ title: "反馈已提交。", position: "top", status: "success" });
      resetForm();
    }
    

  };

  const handleDrop = useCallback(
    (acceptedFiles: File[]) => {
      // 处理接收到的文件，例如上传到服务器
      if (acceptedFiles.length > 0) {
        acceptedFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64File = reader.result as string;
            // console.log(base64File);
            // 在这里可以对base64文件进行进一步处理或发送到服务器
            const newFile =[base64File];
          // files.length > 0 ? [...files, base64File] : [base64File];
          // console.log(newFile, "123");
          setFiles(newFile);
          };
          reader.readAsDataURL(file);
        });
        
        // toast({ title: "图片已上传。", position: "top", status: "success" });
      }
    },
    [toast, files]
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [".jpeg", ".png"],
    },
    maxFiles: 1,
    onDrop: handleDrop,
    multiple: true,
    onDropRejected: () => {
      toast({
        title: "上传的文件类型(仅支持png、jpeg)或数量不符合要求！",
        position: "top",
        status: "error",
      });
    },
  });

  return (
    <Popover placement="left" isOpen={isOpen} onClose={onClose}>
      <PopoverTrigger>
        <Button variant="unstyled" onClick={onToggle}>
          <Icon
            as={RiFeedbackFill}
            boxSize={"32px"}
            color={isOpen ? "#496AE1" : "#B9B9B9"}
          />
          <Text fontSize={"12px"} color={isOpen ? "#496AE1" : "#B9B9B9"}>
            问题反馈
          </Text>
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        {/* <PopoverArrow /> */}
        <PopoverCloseButton />
        <PopoverHeader>
          <Center fontSize={"14px"} color="#27314D">
            问题反馈
          </Center>
        </PopoverHeader>
        <PopoverBody>
          {/* <Box h="300px" bgColor="rgba(238, 241, 247, 0.5)" p="16px"></Box> */}
          <Formik
            initialValues={form}
            onSubmit={handleSubmit}
            validate={handleValidate}
          >
            {({ isSubmitting }) => (
              <Form>
                <Box mb="20px">
                  <Field name="problem">
                    {({ field, form }: any) => (
                      <FormControl
                        isInvalid={
                          form.errors.problem && form.touched.problem
                        }
                      >
                        <FormLabel
                          mb={"10px"}
                          fontSize={"12px"}
                          color="#27314D"
                        >
                          *问题反馈
                        </FormLabel>
                        <Textarea
                          {...field}
                          fontSize={"12px"}
                          color="#8E94A9"
                          border="none"
                          placeholder="请填写您的问题和意见，感谢您的支持～"
                          size="sm"
                          rows={3}
                          resize={"none"}
                          focusBorderColor="transparent"
                          _focus={{
                            borderColor: "transparent",
                          }}
                          bgColor="rgba(238, 241, 247, 0.5)"
                        />
                        <FormErrorMessage>
                          {form.errors.problem}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </Box>

                <Box mb="20px">
                  <Field name="img">
                    {({ field, form }: any) => (
                      <FormControl
                        isInvalid={form.errors.img && form.touched.img}
                      >
                        <FormLabel
                          mb={"10px"}
                          fontSize={"12px"}
                          color="#27314D"
                        >
                          *图片
                        </FormLabel>
                        <Flex gap="10px">
                          {files &&
                            files.map((file) => {
                              return (
                                <Image
                                  boxSize={"76px"}
                                  key={file}
                                  // src={URL.createObjectURL(file)}
                                  src={file}
                                />
                              );
                            })}
                          <Box
                            {...getRootProps()}
                            h="76px"
                            w="76px"
                            justifyContent="center"
                          >
                            <input {...getInputProps()} />
                            <Flex
                              // flex={1}
                              h="76px"
                              w="76px"
                              bgColor={"#EEF1F7"}
                              flexDirection={"column"}
                              justifyContent="center"
                              gap="8px"
                              alignItems="center"
                              color={"#8E94A9"}
                              fontSize="12px"
                            >
                              <Icon boxSize={"16px"} as={RiImage2Line} />
                              <Text>本地上传</Text>
                            </Flex>
                          </Box>
                        </Flex>

                        <FormErrorMessage>
                          {form.errors.img}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </Box>

                <Box mb="20px">
                  <Field name="phone">
                    {({ field, form }: any) => (
                      <FormControl
                        isInvalid={form.errors.phone && form.touched.phone}
                      >
                        <FormLabel
                          mb={"10px"}
                          fontSize={"12px"}
                          color="#27314D"
                        >
                          *手机号
                        </FormLabel>
                        <Input
                          {...field}
                          fontSize={"12px"}
                          color="#8E94A9"
                          border="none"
                          placeholder="请输入手机号便于联系"
                          size="sm"
                          focusBorderColor="transparent"
                          _focus={{
                            borderColor: "transparent",
                          }}
                          bgColor="rgba(238, 241, 247, 0.5)"
                        />
                        <FormErrorMessage>{form.errors.phone}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </Box>
                <Flex justifyContent={"center"} p="20px 16px">
                  <Button
                    borderRadius={"0px"}
                    width={"56px"}
                    height={"29px"}
                    color="#FFFFFF"
                    bgColor="#496AE1"
                    fontWeight={"normal"}
                    fontSize="12px"
                    _hover={{
                      bgColor: "#3F5BC1",
                      color: "#E6E6E6",
                    }}
                    type="submit"
                    isLoading={isSubmitting}
                  >
                    提交
                  </Button>
                </Flex>
              </Form>
            )}
          </Formik>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default FeedbackPopover;
